uniform float time;
uniform float progress;
uniform float distanceFromCenter;
uniform sampler2D texture1;
uniform vec4 resolution;
varying vec2 vUv;
varying vec3 vPosition;
float PI = 3.141592653589793238;

uniform vec2 uTextureSize;
uniform vec2 uQuadSize;

vec2 getUV(vec2 uv, vec2 textureSize, vec2 quadSize){
    vec2 tempUV = uv - vec2(.5);

    float quadAspect = quadSize.x / quadSize.y;
    float textureAspect = textureSize.x / textureSize.y;

    if(quadAspect < textureAspect){
        tempUV = tempUV * vec2(quadAspect/textureAspect, 1.0);
    }else{
        tempUV = tempUV * vec2(1.0, textureAspect/quadAspect);
    }

    tempUV += vec2(.5);
    return tempUV;
}


void main() {
  vec2 correctUV = getUV(vUv, uTextureSize, uQuadSize);
  vec4 t = texture2D(texture1, correctUV);
  float bw = (t.r + t.b + t.g)/3.;
  vec4 another = vec4(bw,bw,bw,1.);
  gl_FragColor = mix(another,t,distanceFromCenter);
  gl_FragColor.a = clamp(distanceFromCenter,0.3,1.);
}